var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"dialog-content",attrs:{"tile":""}},[(_vm.message)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_c('v-card-text',[_vm._v("Are you sure you want to delete "+_vm._s(_vm.elementName)+"?\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }